import { LANDING_PAGE_CONTENT_MAX_WIDTH } from 'app/components/web/dashboard-layout-constants';
import { Column, Row } from 'app/design/primitives/box';
import { createTheme as createDSTheme } from 'app/shopify';
import { StyleSheet } from 'react-native';
import { LandingProfileSummary, LandingQuickActions, useLandingPageNavigationActions } from './shared';
import { type useLandingPage } from './use-landing-page';

const theme = createDSTheme();

const styles = StyleSheet.create({
  page: {
    alignSelf: 'center',
    maxWidth: LANDING_PAGE_CONTENT_MAX_WIDTH,
    paddingTop: theme.spacing['spacing.general.x8'],
    width: '100%',
  },
  headerRow: {
    flexWrap: 'wrap',
  },
  headerIcon: {
    fontSize: 28,
    marginLeft: theme.spacing['spacing.general.x1'],
  },
});

export function DesktopHeader({
  activitySubtitle,
  addressLabel,
  greeting,
  isLoggedIn,
  navigation,
  profile,
  statsLoaded,
  hasLateLoans,
  unreadCount,
  user,
}: {
  activitySubtitle: string;
  addressLabel: string;
  greeting: string;
  isLoggedIn: boolean;
  navigation: ReturnType<typeof useLandingPage>['navigation'];
  profile: ReturnType<typeof useLandingPage>['profile'];
  statsLoaded: boolean;
  hasLateLoans: boolean;
  unreadCount: number;
  user: ReturnType<typeof useLandingPage>['user'];
}) {
  return (
    <Row rowGap="spacing.general.x4" columnGap="spacing.general.x4" alignItems="center" style={styles.headerRow}>
      <Column style={{ marginRight: 'auto' }}>
        <LandingProfileSummary
          addressLabel={addressLabel}
          greeting={greeting}
          navigation={navigation}
          profile={profile}
          user={user}
          variant="large"
        />
      </Column>
      <LandingQuickActions
        actions={useLandingPageNavigationActions(navigation)}
        activitySubtitle={activitySubtitle}
        isLoggedIn={isLoggedIn}
        statsLoaded={statsLoaded}
        hasLateLoans={hasLateLoans}
        unreadCount={unreadCount}
        variant="large"
      />
    </Row>
  );
}
